import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faMicrophone, faMicrophoneSlash, faPlay, faPause,
} from '@fortawesome/free-solid-svg-icons';

import {
  AudioControl, AudioLabel, RoomContainer, LaneTitle, PlayLiveAudioButton, PlayPauseMusic,
} from './styles';

const Room = ({
  roomObject,
  isConnected,
  toggle,
  allRooms,
}) => {
  const { roomId, laneName, status } = roomObject;

  if (!isConnected) {
    return false;
  }

  return (
    <RoomContainer allRooms={allRooms}>

      <LaneTitle>{laneName}</LaneTitle>
      <PlayLiveAudioButton
        blink
        isLiveAudioPlaying={status.speaking}
        onClick={() => toggle(roomId, 'speaking')}
      >
        <FontAwesomeIcon
          size="4x"
          color="white"
          icon={status.speaking ? faMicrophone : faMicrophoneSlash}
        />
      </PlayLiveAudioButton>

      <AudioControl
        playing={status.preAuctionAudio}
        onClick={() => toggle(roomId, 'preAuctionAudio')}
        blink
      >
        <AudioLabel>Pre-Auction Audio</AudioLabel>
        <FontAwesomeIcon
          size="2x"
          color="white"
          icon={status.preAuctionAudio ? faPause : faPlay}
        />
      </AudioControl>

      <AudioControl
        playing={status.pauseAudio}
        onClick={() => toggle(roomId, 'pauseAudio')}
        blink
      >
        <AudioLabel>Pause Audio</AudioLabel>
        <FontAwesomeIcon
          size="2x"
          color="white"
          icon={status.pauseAudio ? faPause : faPlay}
        />
      </AudioControl>

      <AudioControl
        playing={status.postAuctionAudio}
        onClick={() => toggle(roomId, 'postAuctionAudio')}
        blink
      >
        <AudioLabel>Post Auction Audio</AudioLabel>
        <FontAwesomeIcon
          size="2x"
          color="white"
          icon={status.postAuctionAudio ? faPause : faPlay}
        />
      </AudioControl>

      <p>
        {roomId}
      </p>
    </RoomContainer>
  );
};

Room.propTypes = {
  roomObject: PropTypes.object.isRequired,
  toggle: PropTypes.func.isRequired,
  isConnected: PropTypes.bool,
  allRooms: PropTypes.bool,
};

Room.defaultProps = {
  isConnected: false,
  allRooms: false,
};

export default Room;
